import Http from '../core/fetch';
import {
    SET_AVAILABLE_SEARCH_TABS,
    HIDE_SNAP_ASSISTANT_REMINDER,
    SHOW_SNAP_ASSISTANT_REMINDER,
} from './actionsNamesList';

function getFeatureName(feature) {
    switch (feature) {
        case 'mtd': {
            return 'MtdEnableLogin';
        }
        case 'local': {
            return 'LocalEnableLogin';
        }
        case 'flavor': {
            return 'FlavorPermissionId';
        }
        case 'scores': {
            return 'ScoresEnableLogin';
        }
        case 'scores-cl': {
            return 'ScoresConceptLockerPermissionId';
        }
        case 'firefly': {
            return 'FireflyEnableLogin';
        }
        case 'social': {
            return 'DatassentialOneSocialDataPermissionId';
        }
        case 'brandPerformances': {
            return 'FingerprintsEnableLogin';
        }
        case 'chains': {
            return 'SnapFeaturesFireflyChainsId';
        }
        case 'macs': {
            return 'MtdMac';
        }
        default: {
            return '';
        }
    }
}


export function showSnapAssistantReminder() {
    return {
        type: SHOW_SNAP_ASSISTANT_REMINDER
    };
}

export function hideSnapAssistantReminder() {
    return {
        type: HIDE_SNAP_ASSISTANT_REMINDER
    };
}

export function setAvailableSearchTabs(data) {
    return {
        type: SET_AVAILABLE_SEARCH_TABS,
        data
    };
}

export function requestTrialByFeature(feature) {
    return () => {
        const featureName = getFeatureName(feature);
        if (!feature) return '';
        return Http.get('request by feature name', {
            feature: featureName
        });
    };
}
